import Splide from '@splidejs/splide';

(($, Drupal) => {
  const initProgressBarCarousel = (el) => {
    const root = $(el);
    const bar = $(el).find('.progress-bar-carousel__progress-bar');
    const slides = root.find('.splide__slide');

    const slider = new Splide(el, {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      drag: true,
      focus: 'left',
      trimSpace: false,
      autoHeight: true,
      autoWidth: true,
      speed: 600,
      pagination: false,
      keyboard: true,
      mediaQuery: 'min',
      classes: {
        arrows: 'splide__arrows',
        arrow: 'splide__arrow btn btn--icon-filled',
        prev: 'splide__arrow--prev progress-bar-carousel__arrow--prev btn--icon-chevron-left',
        next: 'splide__arrow--next progress-bar-carousel__arrow--next btn--icon-chevron-right',
      },
      breakpoints: {
        320: {
          drag: true,
          arrows: false,
          gap: '0.75rem',
          perPage: 1,
        },
        768: {
          drag: true,
          arrows: false,
          gap: '1rem',
          perPage: 2,
        },
        1024: {
          arrows: false,
          gap: '1rem',
          perPage: 3,
        },

        1140: {
          arrows: true,
          gap: '1rem',
          perPage: 3,
        },

        1440: {
          arrows: true,
          gap: '1rem',
          perPage: 'auto',
        },
      },
    });

    slider.on('mounted move', () => {
      const arrowPrev = $(el).find('.splide__arrow--prev');
      const arrowNext = $(el).find('.splide__arrow--next');

      if (slider.index === 0) {
        $(arrowPrev).addClass('hidden');
      } else {
        $(arrowPrev).removeClass('hidden');
      }

      if (slider.index === slides.length - 1) {
        $(arrowNext).addClass('hidden');
      } else {
        $(arrowNext).removeClass('hidden');
      }

      const end = slider.Components.Controller.getEnd() + 1;
      const rate = Math.min((slider.index + 1) / end, 1);
      bar.css({ width: `${`${String(100 * rate)}%`}` });
    });

    slider.on('mounted', () => {
      slides.each((i, slide) => {
        const id = `${$(slide).attr('id')}-content`;
        const src = `#${id}`;

        const content = $(slide).find('[data-fancybox-target]');
        content.attr('id', id);

        $(slide).attr('data-src', src);
      });
    });

    slider.mount();
  };

  Drupal.behaviors.mstProgressbarCarousel = {
    attach: (context) => {
      $('.progress-bar-carousel', context).each((index, element) => {
        const splideNumber = `progress-bar-carousel-${index}`;
        $(element).addClass(splideNumber);
        $(element).attr('id', splideNumber);
        initProgressBarCarousel(`.${splideNumber}`);
      });
    },
  };
})(jQuery, Drupal);
